import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/EditRounded';
import DeleteIcon from '@mui/icons-material/DeleteRounded';
import Tooltip from '@mui/material/Tooltip';

export default function TagsTable(props) {

    if ((Array.isArray(props.items)) && (props.items.length === 0)) {
        return null
    }

    return (
        <TableContainer component={Paper}>
            <Table size="small" sx={{ minWidth: 650 }}>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ width: 600 }} align="center">Prompt</TableCell>
                        <TableCell sx={{ width: 80 }} align="center">Actions</TableCell>
                        <TableCell />
                    </TableRow>
                </TableHead>
                <TableBody>
                    {(props.category ? props.category.children : []).map((row) => (
                    <TableRow 
                        hover
                        key={row.id}
                        sx={{ cursor: 'pointer' }}
                        onClick={() => {props.btnEditHandle(row)} }
                    >
                        <TableCell sx={{ whiteSpace: 'pre-wrap' }}>{row.content}</TableCell>
                        <TableCell>
                            <Stack direction="row">
                                <Tooltip arrow title="Edit Prompt">
                                    <IconButton 
                                        component="label" 
                                        onClick={() => {props.btnEditHandle(row)} }
                                    >
                                        <EditIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip arrow title="Delete Prompt">
                                    <IconButton 
                                        component="label" 
                                        onClick={(e) => {e.stopPropagation(); props.btnDeleteHandle(row)} }
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                </Tooltip>
                            </Stack>
                        </TableCell>
                        <TableCell />
                    </TableRow>
                    ))}

                    {props.category && props.category.children.length ? '' :
                    (
                        <TableRow>
                            <TableCell sx={{ textAlign: 'center', padding: 5 }}>
                                To add a prompt, click the "Add Prompt" button.
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
